import * as React from "react";
import { IDispatcher } from "../../helpers/Dispatcher";

interface NoteProps {
	content?: string;
	dispatcher: IDispatcher;
}

const Note = (props: NoteProps) => {
	let str_content = props.content;
	const regex1 = /\$percent\(([a-zA-Z0-9]*)\,([a-zA-Z0-9]*)\,([a-zA-Z0-9]*)\)/;
	const match1 = str_content.match(regex1);
	if (match1 && match1.length === 4) {
		const val1 = parseFloat(props.dispatcher.pullValue(match1[1]));
		const val2 = parseFloat(props.dispatcher.pullValue(match1[2]));
		const def = match1[3];
		if (val1 && !Number.isNaN(val1) && val2 && !Number.isNaN(val2)) {
			const value = Math.round((val1 / val2) * 100);
			str_content = str_content.replace(regex1, value.toString());
		} else if (def) {
			str_content = str_content.replace(regex1, def.toString());
		} else {
			str_content = str_content.replace(regex1, "");
		}
	}
	return <div className="alert alert-info alert-dismissable">{str_content}</div>;
};

export default Note;
